import React, { Component } from 'react';
import { Form as ImportForm } from 'semantic-ui-react';
import excludeKeys from '../../../../../utils/excludeKeys';

class FormButton extends Component {
  render() {
    return (
      <ImportForm.Button {...excludeKeys(this.props)} />
    );
  }
}

export default FormButton;
